import PropTypes from 'prop-types';
import React from 'react';
import { Typography } from '@sm/wds-react';

import { ComparisonTableHeaderCell } from '~pricing/components/ComparisonTable';
import { PackagePropTypes, PackageComparisonPropTypes } from '~pricing/lib/proptypes';

const SummaryComparisonTableHeader = ({ pricingPackage, packageTableDetails, a11yId }) => (
  <ComparisonTableHeaderCell a11yId={a11yId}>
    <Typography variant="cardTitle" component="strong" data-testid="SummaryComparisonTableHeader__Label">
      {pricingPackage.details.label}
    </Typography>
    <Typography variant="body" component="p" data-testid="SummaryComparisonTableHeader__Byline">
      {packageTableDetails.byline}
    </Typography>
  </ComparisonTableHeaderCell>
);

SummaryComparisonTableHeader.propTypes = {
  pricingPackage: PropTypes.shape(PackagePropTypes).isRequired,
  packageTableDetails: PropTypes.shape(PackageComparisonPropTypes).isRequired,
  a11yId: PropTypes.string.isRequired,
};

export default SummaryComparisonTableHeader;
